// 시트 '조치결과' 정본 — 표기와 등급 조정 규칙을 한 곳에 둔다.
//
// 값은 현장앱이 정한다(2026-09-14 실측: '현장 해결' · '필드팀 요청'). 앱이 새
// 값을 넣는 날 콘솔이 막히면 안 되므로 **enum 으로 좁히지 않고 원문을 그대로**
// 저장하고, 표기만 여기서 갈아 끼운다.
import { ServiceSeverity } from './enums.js';
/**
 * 매장이 그 자리에서 스스로 끝낸 건. 시트 표기는 '현장 해결'.
 *
 * 콘솔에서는 '자체 해결' 로 부른다(오너 결정 2026-09-14) — 콘솔을 보는 사람은
 * 본사이고, 본사 입장에서 중요한 건 "어디서" 가 아니라 "누가" 이기 때문이다.
 */
export const SHEET_OUTCOME_SELF_RESOLVED = '현장 해결';
/**
 * 매장이 필드팀을 불러 달라고 한 건. 시트 표기도 콘솔 표기도 '필드팀 요청'.
 *
 * 캘린더에서 유지보수를 잡아 콘솔이 만든 리포트도 이 값으로 둔다(오너 2026-11-03 — "캘린더에서 유지보수
 * 일정 등록해서 고객사 리포트에 생기는 거도 구분을 '필드팀 요청'으로 넣자"). 필드팀이 가는 방문이기 때문이다.
 */
export const SHEET_OUTCOME_FIELD_REQUEST = '필드팀 요청';
/** 시트 표기 → 콘솔 표기. 여기 없는 값은 **원문 그대로** 보여 준다. */
export const SHEET_OUTCOME_LABELS = {
    [SHEET_OUTCOME_SELF_RESOLVED]: '자체 해결',
};
/**
 * 화면에 쓸 조치결과 표기.
 *
 * 모르는 값을 '기타' 같은 말로 뭉개지 않는다 — 시트에 적힌 말이 그대로 보여야
 * 운영자가 시트와 콘솔을 대조할 수 있다.
 */
export function sheetOutcomeLabel(raw) {
    const v = raw?.trim();
    if (!v)
        return null;
    return SHEET_OUTCOME_LABELS[v] ?? v;
}
/** 시트가 '현장 해결' 이라고 적었는가. 앞뒤 공백만 흘린다. */
export function isSelfResolved(raw) {
    return raw?.trim() === SHEET_OUTCOME_SELF_RESOLVED;
}
/** 한 단계 낮추기. P3 아래는 없으므로 P3 는 그대로 둔다. */
const ONE_STEP_DOWN = {
    [ServiceSeverity.P1]: ServiceSeverity.P2,
    [ServiceSeverity.P2]: ServiceSeverity.P3,
    [ServiceSeverity.P3]: ServiceSeverity.P3,
};
/**
 * 조치결과를 반영한 등급.
 *
 * '현장 해결' 이면 한 단계 낮춘다 — P1(긴급)→P2(일반), P2(일반)→P3(낮음)
 * (오너 결정 2026-09-14). 매장이 이미 스스로 끝낸 건이라, 같은 증상이어도 본사가
 * 움직여야 하는 급함이 한 칸 덜하다. P3 는 더 내려갈 곳이 없어 그대로다.
 *
 * 그 밖의 조치결과('필드팀 요청' 등)와 빈 칸은 시트 등급을 그대로 쓴다.
 */
export function severityAfterOutcome(severity, sheetOutcome) {
    if (!isSelfResolved(sheetOutcome))
        return severity;
    return ONE_STEP_DOWN[severity] ?? severity;
}
//# sourceMappingURL=sheet-outcome.js.map